import { render } from "./FeedbackFab.vue?vue&type=template&id=62aca044&scoped=true"
import script from "./FeedbackFab.vue?vue&type=script&lang=js"
export * from "./FeedbackFab.vue?vue&type=script&lang=js"

import "./FeedbackFab.vue?vue&type=style&index=0&id=62aca044&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62aca044"]])

export default __exports__